import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { distinctUntilChanged } from 'rxjs/operators';

import { checkIfDateExpired, getFormattedDate } from '@shared/utils';

@Component({
  selector: 'app-dialog-iban-reminder',
  templateUrl: './dialog-iban-reminder.component.html',
  styleUrls: ['./dialog-iban-reminder.component.scss'],
  standalone: false
})
export class DialogIbanReminderComponent implements OnInit {
  reminderForm: FormGroup;

  @Input() reminderDate: null | string;
  @Input() loading = false;
  @Input() currentLang: string;
  @Output() setIbanReminder: EventEmitter<string> = new EventEmitter<string>();
  @Output() reminderDateChange: EventEmitter<void> = new EventEmitter<void>();
  @Output() cancelReminder: EventEmitter<void> = new EventEmitter<void>();

  get dateTimeControl(): AbstractControl | null {
    return this.reminderForm.get('dateTime');
  }

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.reminderForm = this.initializeForm(this.reminderDate);

    let counter = 0;
    this.dateTimeControl.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      // Do not track initial date change when the reminderDate is not set
      if (this.reminderDate === null && counter === 0) {
        counter += 1;
        return;
      }
      this.reminderDateChange.emit();
    });
  }

  initializeForm(date: null | string): FormGroup {
    return this.fb.group({
      dateTime: [date, Validators.required]
    });
  }

  onCancel() {
    this.cancelReminder.emit();
  }

  onSubmit() {
    if (this.loading) {
      return;
    }

    this.setIbanReminder.emit(this.setValidDate(this.dateTimeControl?.value as string));
  }

  setValidDate(dateString: string) {
    const dateTimeArr: string[] = dateString.split('T');
    const dateArr = dateTimeArr[0].split('-');
    const timeArr = dateTimeArr[1].split(':');
    const chosenDate = new Date(Number(dateArr[0]), Number(dateArr[1]) - 1, Number(dateArr[2]), Number(timeArr[0]), Number(timeArr[1]), 0, 0);
    return getFormattedDate(checkIfDateExpired(chosenDate));
  }
}
